import AxiosInterceptor from 'api/interceptor';

const api = new AxiosInterceptor();

export default {
  find(id) {
    return api.get('/order_options/' + id);
  },
  get() {
      return api.get('/order_options');
  },
  delete(id) {
    return api.delete('/order_options/' + id);
  },
  create(input) {
    return api.post('/order_options', {content:input});
  },
  update(id, input) {
    return api.put('/order_options/' + id, {content:input});
  }
};